// extracted by mini-css-extract-plugin
module.exports = {"button":"ddbutton_button__3IM8r"};